export default __webpack_public_path__ + "static/media/donut-06.0a764b6d.png";